import { createSlice } from "@reduxjs/toolkit";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { IslemApi } from "src/services/Islem/IslemApi";

interface IIslemState {
  data: Array<VwHbsIslemtanimDTO>,
  filter: Array<VwHbsIslemtanimDTO>
}
const IslemSlice = createSlice<IIslemState, MapReducerPayloads<IIslemState, {
  setState: IIslemState,
  setData: Array<VwHbsIslemtanimDTO>,
  setFilter: Array<VwHbsIslemtanimDTO>
}>>({
  name: 'BorcTaahhut',
  initialState: {
    data: [],
    filter: []
  },
  reducers: {
    setState: (state, action) => action.payload,
    setData: (state, action) => {
      state.data = action.payload
    },
    setFilter: (state, action) => {
      state.filter = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(IslemApi.endpoints.getHbsIslemtanim.matchFulfilled, (state, action) => {
      state.data = action.payload?.map(m => m)
    })
  }
})
export default IslemSlice;